// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.variant-form {
  display: flex;
  flex-wrap: wrap;
}
.variant-form > .variant-form-price {
  position: relative;
}
.variant-form > .variant-form-price .variant-form-price-currency {
  position: absolute;
  height: 40px;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--black9);
}
.variant-form > .variant-form-price .variant-form-price-currency + div input {
  padding-left: 2.25rem;
}
@media (max-width: 768px) {
  .variant-form > .variant-form-price {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/variants/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AACN;AACM;EACE,qBAAA;AACR;AAGI;EApBF;IAqBI,sBAAA;EAAJ;AACF","sourcesContent":[".variant-form {\n  display: flex;\n  flex-wrap: wrap;\n\n  & > .variant-form-price {\n    position: relative;\n\n    .variant-form-price-currency {\n      position: absolute;\n      height: 40px;\n      bottom: 0;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      padding: 1rem;\n      font-weight: 500;\n      font-size: .9rem;\n      color: var(--black9);\n\n      & + div input {\n        padding-left: 2.25rem;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100% !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
